<template>
    <div
        class="admin-vue-kit"
        :data-brand-theme="brandThemeAttr"
    >
        <div class="admin-vue-kit__orient">
            <div>
                <div class="admin-vue-kit__title-row">
                    <h1 class="admin-vue-kit__title">{{ title }}</h1>
                    <span v-if="count !== null && count !== undefined" class="admin-vue-kit__badge">{{ count }}</span>
                </div>
                <p v-if="subtitle" class="admin-vue-kit__subtitle">{{ subtitle }}</p>
            </div>
            <div v-if="$slots.actions" class="admin-vue-kit__actions">
                <slot name="actions" />
            </div>
        </div>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'AdminIslandShell',
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: '' },
        count: { type: [Number, String], default: null },
        /** Same key as Start Hub (`admin-start-hub.theme`), `default` when unset. */
        themeKey: { type: String, default: 'default' },
    },
    computed: {
        brandThemeAttr() {
            const key = String(this.themeKey || 'default').trim();
            if (key === '' || key === 'default') {
                return undefined;
            }

            return key;
        },
    },
};
</script>
